import { Provider } from '@angular/core';
import { DetailShiftResourceTypeUseCase } from '@app/application/use-cases/shift-resource';
import { ShiftResourceRepository } from '@app/domain/repositories/shift-resource.repository';
import { ShiftResourceRepositoryImpl } from '../repositories/shift-resource.repository.impl';

export const SHIFT_RESOURCE_PROVIDERS: Provider[] = [
  {
    provide: ShiftResourceRepository,
    useClass: ShiftResourceRepositoryImpl,
  },

  {
    provide: DetailShiftResourceTypeUseCase,
    useFactory: (shiftResourceRepo: ShiftResourceRepository) =>
      new DetailShiftResourceTypeUseCase(shiftResourceRepo),
    deps: [ShiftResourceRepository],
  },
];
